export default class ApiResultHelper {
  private static NORMALIZED_LENGTH = 5;

  static normalizeResultLength<T>(results: T[]) {
    if (!results || !results.length || results.length < 1) return results;

    const normalizedResult = [...results];

    while (normalizedResult.length < ApiResultHelper.NORMALIZED_LENGTH) {
      normalizedResult.push(...results);
    }

    return normalizedResult;
  }
}
